import { get } from "../../utils/httpClient";

const userService = () => {
  const prefixApi = "duedates/users";

  const getUsers = async () => {
    return await get(`/${prefixApi}`);
  };

  const getUser = async (id) => {
    return await get(`/${prefixApi}/${id}`);
  };

  return {
    getUser,
    getUsers,
  };
};

export default userService;
